import React, { useMemo } from 'react'

import { Card, Flex, Link, StatusBadge } from "@driftt/dds"

import { driftEmptyStateBuilder } from 'components/States'
import { AccountSiteVisitInfo } from 'hooks/useAccountDetails'
import { getUrlFragment } from 'utils/urlUtils'

export const TopPages = ({topPages, trackAction}: { 
  topPages: AccountSiteVisitInfo[] | undefined, 
  trackAction: (action: string, data: any) => void
}) => {
  const EmptyComponent = useMemo(
    () =>
      driftEmptyStateBuilder(
        'No page visits found',
        'Not enough activity in the last 2 weeks'
      ),
    []
  )
  return (
    <Card>
      <Card.Header>Top pages</Card.Header>
      <Flex wrap='wrap'>
        {(!topPages || topPages.length < 1) && 
          <EmptyComponent/>
        }
        {topPages?.map(
          (page) => {
            const url = new URL(page.pageUrl)
            return (
              <StatusBadge size='small' variant='pending' key={page.pageUrl}>
                <Link
                css={{fontSize: '12px'}}
                external={true}
                href={page.pageUrl}
                onClick={() => trackAction('Top page link clicked', {url: page.pageUrl})}>
                  {`${url.pathname}${getUrlFragment(page.pageUrl)}`}
                </Link>
              </StatusBadge>
            )
          }
            
        )}
      </Flex>
    </Card>
  )
}